import { NgModule } from '@angular/core';
import { TogglLoginComponent } from './toggle-login/toggl-login.component';
import { CommonModule } from '@angular/common';
import { togglRoutes } from './toggl.routes';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@intranet/shared/shared.module';
import { RouterModule } from '@angular/router';
import { TogglTestComponent } from './toggl-test/toggl-test.component';
import { TogglUserMatchComponent } from './toggl-user-match/toggl-user-match.component';
import { TogglJobMatchComponent } from './toggl-job-match/toggl-job-match.component';
import { TogglTimeEntriesComponent } from './toggl-time-entries/toggl-time-entries.component';
import { TooltipModule } from '@intranet/components/index';
import { TogglScheduleComponent } from './toggl-schedule/toggl-schedule.component';
import { AddScheduleDialog } from './add-schedule-dialog/add-schedule-dialog.component';
import { PipesModule } from '@intranet/core/pipes/pipes.module';
import { TogglTimerButtonModule }   from './toggl-timer-button/toggl-timer-button.module';



@NgModule({
    declarations: [
        TogglLoginComponent,
        TogglTestComponent,
        TogglUserMatchComponent,
        TogglJobMatchComponent,
        TogglTimeEntriesComponent,
        TogglScheduleComponent,
        AddScheduleDialog,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        RouterModule.forChild(togglRoutes),
        // ReactiveFormsModule,
        // MatCurrencyFormatModule,
        // DialogModule,
        PipesModule,
        // ActionModule,
        SharedModule,
        // TabsModule,
        // OverlayModule,
        TooltipModule,
        TogglTimerButtonModule,
    ],
    exports: [TogglLoginComponent, TogglTimerButtonModule],
    providers: [],
    bootstrap: []
})
export class TogglModule {}
